import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as subgroupsConsts from "./constants";

export const state = {
  allSubgroups: []
};

export const getters = {
  [subgroupsConsts.GETTERS_LIST_ALL_SUBGROUPS]: state => {
    return state.allSubgroups;
  }
};

export const actions = {
  [subgroupsConsts.ACTION_GET_ALL_SUBGROUPS_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().subgroups.getSubgroups,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response) {
        commit(subgroupsConsts.MUTATION_SET_ALL_SUBGROUPS_LIST, response);
      }
    });
  }
};

export const mutations = {
  [subgroupsConsts.MUTATION_SET_ALL_SUBGROUPS_LIST]: (state, data) => {
    state.allSubgroups = data;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/subgroup/index.js